(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[21],{

/***/ "2ejy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return track; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d1HQ");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("829J");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




function track(props, appContext) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(props)) {
    return false;
  }

  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_2__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _tracking_constants__WEBPACK_IMPORTED_MODULE_3__[/* GA_DEFAULT_PAYLOAD */ "i"]), props), appContext);
}

/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductBadgeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getServiceAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabelTranslateOptions; });
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("UCZK");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getProductBadgeIcon = function getProductBadgeIcon(_ref) {
  var badgeIcon = _ref.badgeIcon,
      color = _ref.color,
      comfortLabel = _ref.comfortLabel;
  return {
    alt: comfortLabel || '',
    color: _color_colors__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].WHITE,
    colorBg: color,
    colorBorder: color,
    iconName: badgeIcon
  };
};

var getServiceAgesLabel = function getServiceAgesLabel(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "g"])('booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "g"])('booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "g"])('booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  });
};

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}



/***/ }),

/***/ "FpW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ycRU");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0__["createElement"];








var defaultProps = {
  dataSelector: 'BookingPaymentStatus'
};

function BookingPaymentStatus(_ref) {
  var className = _ref.className,
      dataSelector = _ref.dataSelector,
      isBookingPaid = _ref.isBookingPaid,
      shouldProposeOnlinePayment = _ref.shouldProposeOnlinePayment,
      status = _ref.status,
      bookingPaidLabel = _ref.bookingPaidLabel,
      bookingStatusLink = _ref.bookingStatusLink,
      children = _ref.children,
      onClick = _ref.onClick;
  var app = react__WEBPACK_IMPORTED_MODULE_0__["useContext"](_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"]);
  var isBookingValidated = status === _utils_booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_2__[/* BOOKING_PAYMENT_STATUS_VALIDATED */ "f"];

  if (isBookingPaid && isBookingValidated) {
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('BookingPaymentStatus', className),
      "data-selector": dataSelector
    }, __jsx("p", {
      className: "flex items-center"
    }, __jsx("span", {
      className: "BookingPaymentStatus--payed"
    }, bookingPaidLabel), __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
      className: "bg-emerald p-px10 rounded-half",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].WHITE,
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CHECK,
      width: "1.875rem"
    })));
  }

  if (!shouldProposeOnlinePayment || !app.canUseOnlinePayment) {
    return null;
  }

  if (bookingStatusLink) {
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('BookingPaymentStatus', className),
      "data-selector": dataSelector
    }, __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
      dataSelector: "".concat(String(dataSelector), "-button"),
      url: bookingStatusLink.url,
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BOOKING,
      colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BOOKING,
      onClick: onClick,
      dataTestId: "".concat(String(dataSelector), "--button")
    }, bookingStatusLink.label));
  }

  if (children) {
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('BookingPaymentStatus', className),
      "data-selector": dataSelector
    }, children);
  }

  return null;
}

BookingPaymentStatus.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (BookingPaymentStatus);

/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js

var variants = {
  diamond: {
    root: ' rotate-45',
    item: ' -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBg,
        _ref$colorBorder = _ref.colorBorder,
        colorBorder = _ref$colorBorder === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBorder,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref$color,
        hasShadow = _ref.hasShadow,
        variant = _ref.variant;
    return {
      thRoot: "bg-".concat(colorBg, " border-").concat(colorBorder, " text-").concat(color, " border-2 flex-none inline-flex items-center justify-center leading-none overflow-hidden relative").concat(hasShadow ? ' shadow' : '').concat(variant ? variants[variant].root : ''),
      thImage: "absolute inset-0 ".concat(variant ? variants[variant].item : ''),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ".concat(variant ? variants[variant].item : ''),
      thLabelStyle: {
        fontSize: '1em'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx
var __jsx = react_default.a.createElement;





var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      color = _ref.color,
      hasShadow = _ref.hasShadow,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant;

  if (!iconName && !imageSrc && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    colorBg: colorBg,
    colorBorder: colorBorder,
    color: color,
    hasShadow: hasShadow,
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thImage = _themes$theme.thImage,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thRoot = _themes$theme.thRoot;

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: styles
  }, !!imageSrc && __jsx("div", {
    className: thImage
  }, __jsx(Image["b" /* default */], {
    altMsg: alt,
    imageUrl: imageSrc,
    dimensions: imageSize
  })), !!iconName && __jsx("div", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label));
};

/***/ }),

/***/ "blgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_STATUS_ARCHIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_STATUS_VALIDATED; });
/* unused harmony export BOOKING_STATUS_CANCELED */
/* unused harmony export BOOKING_STATUS_QUOTATION */
/* unused harmony export BOOKING_STATUS_HOPE */
/* unused harmony export BOOKING_STATUS_EXPIRED_OPTION */
/* unused harmony export BOOKING_STATUS_EXPIRED_HOPE */
/* unused harmony export BOOKING_STATUS_EXPIRED_QUOTATION */
/* unused harmony export BOOKING_STATUS_REQUEST */
var BOOKING_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_STATUS_CANCELED = 'CANCELED';
var BOOKING_STATUS_QUOTATION = 'QUOTATION';
var BOOKING_STATUS_HOPE = 'HOPE';
var BOOKING_STATUS_EXPIRED_OPTION = 'EXPIRED_OPTION';
var BOOKING_STATUS_EXPIRED_HOPE = 'EXPIRED_HOPE';
var BOOKING_STATUS_EXPIRED_QUOTATION = 'EXPIRED_QUOTATION';
var BOOKING_STATUS_REQUEST = 'REQUEST';
var BOOKING_STATUS_ARCHIVED = 'ARCHIVED';


/***/ }),

/***/ "vakO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("U2CP");
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ycRU");
/* harmony import */ var _booking_status_bookingStatus_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("blgx");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ldK3");











function formatPhoneNumber(agencyPhoneNumber) {
  return agencyPhoneNumber && "tel:".concat(agencyPhoneNumber.replace(/\s/g, ''));
}

function getPhoneNumber(vendor, fallbackPhoneNumber) {
  return vendor && (vendor.isSoldByClubMed && !vendor.phoneNumber ? fallbackPhoneNumber : vendor.phoneNumber);
}

function getAgencyLabel(vendor, cmsContent) {
  var pleaseContactClubMedLabel = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(cmsContent, 'pleaseContactClubMedLabel', null);
  var pleaseContactExternalLabel = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(cmsContent, 'pleaseContactExternalLabel', null);
  return vendor && (vendor.isSoldByClubMed ? pleaseContactClubMedLabel : pleaseContactExternalLabel && Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["messageFormat"])(pleaseContactExternalLabel).format({
    agencyName: vendor.name
  }));
}

function getAgencyDetails(_ref) {
  var vendor = _ref.vendor,
      dedicatedJoyviewHotlineNumber = _ref.dedicatedJoyviewHotlineNumber,
      isJoyview = _ref.isJoyview;
  var agencyPhoneNumber = isJoyview && !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(dedicatedJoyviewHotlineNumber) ? dedicatedJoyviewHotlineNumber : this.getPhoneNumber(vendor, Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "g"])('travelAdvisor.phoneNumber'));
  return {
    label: agencyPhoneNumber,
    url: this.formatPhoneNumber(agencyPhoneNumber)
  };
}

function isPastTrip(returnDate) {
  if (!returnDate) {
    return false;
  }

  return moment__WEBPACK_IMPORTED_MODULE_1___default()(Date.now()).isAfter(moment__WEBPACK_IMPORTED_MODULE_1___default()(returnDate, 'YYYYMMDD'));
}

function shouldDisplayPriceDetail(isSoldByClubMed, displayPriceDetail) {
  return isSoldByClubMed || displayPriceDetail;
}

function getPackageIcon(isAllInclusive, isJoyview) {
  var iconAccommodations = isJoyview ? _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].JOYVIEW_HAND : _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACCOMODATIONS;
  return isAllInclusive ? _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ALL_INCLUSIVE : iconAccommodations;
}

function isOption(informationStatus) {
  return informationStatus === _booking_payment_status_bookingPaymentStatus_constants__WEBPACK_IMPORTED_MODULE_7__[/* BOOKING_PAYMENT_STATUS_OPTION */ "c"];
}

function isArchived(bookingStatus) {
  return bookingStatus === _booking_status_bookingStatus_constants__WEBPACK_IMPORTED_MODULE_8__[/* BOOKING_STATUS_ARCHIVED */ "a"];
}

function shouldDisplayLinkList(userBooking) {
  var currentUri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new urijs__WEBPACK_IMPORTED_MODULE_2___default.a('#');
  var isFeatureFlippedOff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var stay = arguments.length > 3 ? arguments[3] : undefined;
  var prepareMyStayDirectory = new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(Object(_routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__[/* buildUrl */ "a"])('prepareMyStay', {
    bookingId: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(userBooking, 'information.bookingId')
  })).directory();
  var isOnPrepareMyStay = currentUri.directory() === prepareMyStayDirectory.toString();
  return !isOption(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(userBooking, 'information.status')) && !isPastTrip(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'returnDate')) && !isFeatureFlippedOff || isOnPrepareMyStay;
}

function hasTransport(stay) {
  return !!(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'departureCity') || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'arrivalCity'));
}

function hasTransfer(transfers) {
  return !!(transfers && (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(transfers.inbound) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(transfers.outbound)));
}

function findStay(booking, stayId) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays', []);

  if (!stayId && stays.length === 1) {
    return stays[0];
  }

  return stays.find(function (s) {
    return s.id === stayId;
  });
}

function isFirstStay(booking, stayId) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays.0', {}).id === stayId;
}

function findStayFormality(stayFormalities, stayId) {
  return (stayFormalities || []).find(function (s) {
    return s.stayId === stayId;
  });
}

function findTransferDetails(booking, stayId) {
  var stay = findStay(booking, stayId);
  if (!stay) return;
  return (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'transferDetails') || []).find(function (transfer) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transfer, 'inbound.date') === (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'departureDate') || Number.NaN).toString() || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transfer, 'outbound.date') === (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(stay, 'returnDate') || Number.NaN).toString();
  });
}

function isMultiStay(booking) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays');
  return stays && stays.length > 1;
}

function findCurrentStay(booking) {
  var stays = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(booking, 'information.stays', []);
  if (stays.length === 0) return null;
  if (stays.length === 1) return stays[0];
  var now = moment__WEBPACK_IMPORTED_MODULE_1___default()();
  var res = stays.find(function (stay) {
    return stay.departureDate && stay.returnDate && Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* momentFromApiDate */ "h"])(stay.departureDate).isBefore(now) && Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_9__[/* momentFromApiDate */ "h"])(stay.returnDate).isAfter(now);
  });
  return res || stays[0];
}

function isTour(stay) {
  return stay.productType === 'TOUR';
}

function isCruise(stay) {
  return stay.productType === 'CRUISE';
}

function getTranportIcon(transportType) {
  switch (transportType) {
    case 'TRAIN':
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRAIN;

    case 'BOAT':
    case 'FERRY':
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].BOAT;

    default:
      return _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSPORT;
  }
}

function isSoldByClubmed(vendor) {
  return vendor === 'CLUBMED';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  formatPhoneNumber: formatPhoneNumber,
  getPhoneNumber: getPhoneNumber,
  getAgencyLabel: getAgencyLabel,
  getAgencyDetails: getAgencyDetails,
  getPackageIcon: getPackageIcon,
  isPastTrip: isPastTrip,
  shouldDisplayPriceDetail: shouldDisplayPriceDetail,
  shouldDisplayLinkList: shouldDisplayLinkList,
  hasTransport: hasTransport,
  hasTransfer: hasTransfer,
  isOption: isOption,
  isArchived: isArchived,
  findStay: findStay,
  isMultiStay: isMultiStay,
  findStayFormality: findStayFormality,
  findCurrentStay: findCurrentStay,
  isFirstStay: isFirstStay,
  findTransferDetails: findTransferDetails,
  isTour: isTour,
  isCruise: isCruise,
  getTranportIcon: getTranportIcon,
  isSoldByClubmed: isSoldByClubmed
});

/***/ }),

/***/ "ycRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOOKING_PAYMENT_STATUS_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOKING_PAYMENT_STATUS_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_PAYMENT_STATUS_CART; });
var BOOKING_PAYMENT_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_PAYMENT_STATUS_OPTION = 'OPTION';
var BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE = 'PACKAGE_UPGRADE';
var BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE = 'ADDITIONAL_SERVICE';
var BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM = 'PICK_YOUR_ROOM';
var BOOKING_PAYMENT_STATUS_CART = 'CART';


/***/ }),

/***/ "zgAg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TravelDetails_TravelDetails; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/utils/ple-utils/bookingUtils.js
var bookingUtils = __webpack_require__("vakO");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/travel-detail/TravelDetail.jsx
var __jsx = react_default.a.createElement;






var Detail = function Detail(_ref) {
  var highlightText = _ref.highlightText,
      text = _ref.text;

  if (!text && !highlightText) {
    return null;
  }

  return __jsx("p", {
    className: "reset-paragraph"
  }, text, "\xA0", __jsx("strong", {
    className: "text-blue"
  }, highlightText));
};

var TravelDetail_TravelDetail = function TravelDetail(_ref2) {
  var icon = _ref2.icon,
      _ref2$infos = _ref2.infos,
      infos = _ref2$infos === void 0 ? {} : _ref2$infos;
  return __jsx("div", {
    className: "flex items-center py-px10 text-base"
  }, __jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 mx-px10",
    color: colors["a" /* COLORS */].BLUE,
    name: icon,
    width: "1.75rem"
  }), !Object(lodash["isEmpty"])(infos) && __jsx("div", {
    className: "flex-1 mx-px10"
  }, __jsx(Detail, {
    text: infos.text1,
    highlightText: infos.highlightText1
  }), __jsx(Detail, {
    text: infos.text2,
    highlightText: infos.highlightText2
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/duration/DurationTravelDetails.jsx
var DurationTravelDetails_jsx = react_default.a.createElement;






var DurationTravelDetails_DurationTravelDetails = function DurationTravelDetails(_ref) {
  var className = _ref.className,
      departureDate = _ref.departureDate,
      returnDate = _ref.returnDate;
  return departureDate && returnDate ? DurationTravelDetails_jsx(TravelDetail_TravelDetail, {
    className: className,
    icon: icons["a" /* ICONS */].DATE,
    infos: {
      text1: Object(i18n["g" /* t */])('common.duration.from'),
      highlightText1: moment_default()(departureDate, apiDate["a" /* API_DATE_FORMAT */]).format(Object(i18n["g" /* t */])('stays.dateFormat')),
      text2: Object(i18n["g" /* t */])('common.duration.to'),
      highlightText2: moment_default()(returnDate, apiDate["a" /* API_DATE_FORMAT */]).format(Object(i18n["g" /* t */])('stays.dateFormat'))
    }
  }) : null;
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/participants/ParticipantsTravelDetails.jsx

var ParticipantsTravelDetails_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ParticipantsTravelDetails_getAdultsLabel = function getAdultsLabel(number) {
  return Object(i18n["g" /* t */])(number > 1 ? 'common.participants.adults._n' : 'common.participants.adults._1', {
    count: number
  });
};

var ParticipantsTravelDetails_getChildrenProps = function getChildrenProps(number) {
  return number ? {
    text2: Object(i18n["g" /* t */])('common.and'),
    highlightText2: Object(i18n["g" /* t */])(number > 1 ? 'common.participants.children._n' : 'common.participants.children._1', {
      count: number
    })
  } : null;
};

var ParticipantsTravelDetails_ParticipantsTravelDetails = function ParticipantsTravelDetails(_ref) {
  var adultsCounter = _ref.adultsCounter,
      childrenCounter = _ref.childrenCounter,
      className = _ref.className;
  return adultsCounter ? ParticipantsTravelDetails_jsx(TravelDetail_TravelDetail, {
    className: className,
    icon: icons["a" /* ICONS */].USERS,
    infos: _objectSpread({
      text1: Object(i18n["g" /* t */])('common.participants.for', {
        a: ''
      }).trim(),
      highlightText1: ParticipantsTravelDetails_getAdultsLabel(adultsCounter)
    }, ParticipantsTravelDetails_getChildrenProps(childrenCounter))
  }) : null;
};
// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/transport/TransportTravelDetails.jsx
var TransportTravelDetails_jsx = react_default.a.createElement;








var TransportTravelDetails_formatCallToUpsellTransportLabel = function formatCallToUpsellTransportLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      vendor = _ref.vendor;
  var callToUpsellTransportLabel = Object(i18n["g" /* t */])('memberSpace.trips.transport.callToUpsellTransportLabel');
  var params = {
    dedicatedJoyviewHotlineNumber: Object(i18n["g" /* t */])('memberSpace.trips.dedicatedJoyviewHotlineNumber'),
    isJoyview: isJoyview,
    vendor: vendor
  }; // $FlowFixMe

  var agencyDetails = bookingUtils["a" /* default */].getAgencyDetails(params);
  return callToUpsellTransportLabel ? Object(dist["messageFormat"])(callToUpsellTransportLabel).format({
    agencyNumber: Object(lodash["get"])(agencyDetails, 'label', '')
  }) : '';
};

var TransportTravelDetails_TransportTravelDetails = function TransportTravelDetails(props) {
  var arrivalCity = props.arrivalCity,
      bookingStatus = props.bookingStatus,
      className = props.className,
      departureCity = props.departureCity,
      returnDate = props.returnDate,
      transportType = props.transportType;
  var hasTransport = departureCity && arrivalCity;
  var isSearch = bookingStatus === 'SEARCH';

  if (!hasTransport) {
    var highlightText = bookingUtils["a" /* default */].isPastTrip(returnDate) || isSearch ? '' : TransportTravelDetails_formatCallToUpsellTransportLabel(props);
    return TransportTravelDetails_jsx(TravelDetail_TravelDetail, {
      className: className,
      icon: icons["a" /* ICONS */].NO_TRANSPORT,
      infos: {
        text1: Object(i18n["g" /* t */])('booking.form.withoutTransport'),
        highlightText2: highlightText
      }
    });
  }

  return TransportTravelDetails_jsx(TravelDetail_TravelDetail, {
    className: className,
    icon: bookingUtils["a" /* default */].getTranportIcon(transportType),
    infos: {
      text1: Object(i18n["g" /* t */])('common.duration.from'),
      highlightText1: departureCity,
      text2: Object(i18n["g" /* t */])('common.duration.to'),
      highlightText2: arrivalCity
    }
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/travel-details/TravelDetails.jsx

var TravelDetails_jsx = react_default.a.createElement;







var propsForTransportTravelDetails = function propsForTransportTravelDetails(vendor, bookingStatus) {
  var _stay$resort;

  var stay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    arrivalCity: stay.arrivalCity,
    bookingStatus: bookingStatus,
    departureCity: stay.departureCity,
    isJoyview: (_stay$resort = stay.resort) === null || _stay$resort === void 0 ? void 0 : _stay$resort.isJoyview,
    returnDate: stay.returnDate,
    transportType: stay.transportType,
    vendor: vendor
  };
};

var TravelDetails_TravelDetails = function TravelDetails(_ref) {
  var _stay$resort2;

  var bookingStatus = _ref.bookingStatus,
      className = _ref.className,
      isVertical = _ref.isVertical,
      stay = _ref.stay,
      vendor = _ref.vendor;
  var isJoyview = stay === null || stay === void 0 ? void 0 : (_stay$resort2 = stay.resort) === null || _stay$resort2 === void 0 ? void 0 : _stay$resort2.isJoyview;
  var isArchived = bookingUtils["a" /* default */].isArchived(bookingStatus);
  return stay ? TravelDetails_jsx("div", {
    className: classnames_default()(className, 'flex flex-col justify-around', {
      'sm:flex-row': !isVertical
    })
  }, TravelDetails_jsx(DurationTravelDetails_DurationTravelDetails, {
    className: "flex-1",
    departureDate: stay.departureDate,
    returnDate: stay.returnDate
  }), !isArchived && TravelDetails_jsx(ParticipantsTravelDetails_ParticipantsTravelDetails, {
    adultsCounter: stay.adults || 0,
    childrenCounter: stay.children || 0,
    className: "flex-1"
  }), !isJoyview && // $FlowFixMe
  TravelDetails_jsx(TransportTravelDetails_TransportTravelDetails, Object(esm_extends["a" /* default */])({
    className: "flex-1"
  }, propsForTransportTravelDetails(vendor, bookingStatus, stay)))) : null;
};

/***/ })

}]);